import React from 'react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { REJECTION_REASONS } from '../constants';

interface RejectionReasonSelectProps {
  value: string;
  onChange: (value: string) => void;
  /** Custom reason text when "Other" is selected */
  otherReason?: string;
  /** Callback when other reason text changes */
  onOtherReasonChange?: (value: string) => void;
}

export const RejectionReasonSelect: React.FC<RejectionReasonSelectProps> = ({
  value,
  onChange,
  otherReason = '',
  onOtherReasonChange,
}) => {
  const isOtherSelected = value === 'Other';

  return (
    <div className="space-y-2">
      <div className="space-y-1">
        <Label
          htmlFor="rejection-reason"
          className="text-xs font-medium text-gray-700"
        >
          Rejection Reason
        </Label>
        <Select value={value || undefined} onValueChange={onChange}>
          <SelectTrigger id="rejection-reason" className="w-full text-xs">
            <SelectValue placeholder="Select rejection reason" />
          </SelectTrigger>
          <SelectContent className="max-h-[300px] overflow-y-auto">
            {REJECTION_REASONS.map((reason) => (
              <SelectItem key={reason} value={reason} className="text-xs">
                {reason}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Show free text field when "Other" is selected */}
      {isOtherSelected && (
        <div className="space-y-1">
          <Label
            htmlFor="other-reason"
            className="text-xs font-medium text-gray-700"
          >
            Please specify
          </Label>
          <Input
            id="other-reason"
            type="text"
            value={otherReason}
            onChange={(e) => onOtherReasonChange?.(e.target.value)}
            placeholder="Enter reason..."
            className="w-full text-xs"
          />
        </div>
      )}
    </div>
  );
};

export default RejectionReasonSelect;
